import { cj } from 'src/utils/classNames';
import useVelocityStore from 'src/stores/VelocityStore/useVelocityStore';
import {
	CategorisedLiquidity,
	CUMULATIVE_SIZE_CURRENCY,
} from '@velocity-exchange/common';
import { BigNum, BN } from '@velocity-exchange/sdk';
import { trimDisplayZeros } from 'src/utils/formatNumber/trimDisplayZeros';

interface OrderbookSizeProps {
	rowSize: CategorisedLiquidity;
	baseDisplayDecimals: number;
	isMobile: boolean;
	className: string;
	currency: CUMULATIVE_SIZE_CURRENCY;
	price: number;
}

export const OrderbookRowSize = ({
	rowSize,
	baseDisplayDecimals,
	isMobile,
	className,
	currency,
	price,
}: OrderbookSizeProps) => {
	const set = useVelocityStore((s) => s.set);

	const rowTotalSize = Object.values(rowSize).reduce(
		(acc, curr) => acc + curr,
		0
	);

	const displayValue =
		currency === CUMULATIVE_SIZE_CURRENCY.USD && price
			? rowTotalSize * price
			: rowTotalSize;

	const displayDecimals =
		currency === CUMULATIVE_SIZE_CURRENCY.USD ? 2 : baseDisplayDecimals;

	const formattedSize = BigNum.fromPrint(
		displayValue.toFixed(displayDecimals),
		new BN(displayDecimals)
	).toMillified(3);

	const handleSizeClick = (size: number) => {
		set((state) => {
			state.tradeForm.leadSide = 'base';
			// Round size to 5 decimals... avoids a bunch of zeroes in trade form
			const roundTo = 10 ** 5;
			// @ts-expect-error - we want to override the readonly property
			state.tradeForm.baseSizeStringValue = trimDisplayZeros(
				(Math.round(size * roundTo) / roundTo).toString()
			);
		});
	};

	return (
		<span
			className={cj(
				'inline-flex items-center text-right',
				!isMobile && 'hover:cursor-pointer hover:brightness-125',
				className
			)}
			onClick={() => handleSizeClick(rowTotalSize)}
		>
			{formattedSize}
		</span>
	);
};
